import React, { useState } from "react";
import { Button, Modal, TableAdv } from "../../../../components";
import { paymentrowdata } from "../../../../assets/data/candidatesData";
import { mapTableRows } from "../../../../utils";
import Checkbox from "../../../../components/FormFields/Checkbox";
import EditPayment from "./Payments/EditPayment";
import CreatePayment from "./Payments/CreatePayment";
import InvoiceDetails from "../../Invoices/Invoices/InvoiceDetails";
import ApInvoiceDetails from "../Modals/ApInvoiceDetails";

const Payments = () => {
  const [showCreatePayment, setShowCreatePayment] = useState(false);
  const tablerowData = paymentrowdata;

  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [view, setView] = useState("list");
  const [selectedRows, setSelectedRows] = useState([]);

  const handleInvoiceNumberClick = (row) => {
    setSelectedInvoice(row);
    setView("details");
    console.log(row);
  };

  const handelcreatePayment = () => {
    setShowCreatePayment(true);
  };

  const handleBackToPayments = () => {
    setShowEditPayment(false);
    setShowCreatePayment(false);
  };

  const PaymentColumns = [
    {
      key: "InvoiceNumber",
      label: "Invoice Number",
      render: (row) => (
        <span
          className="cursor-pointer text-linkblue"
          onClick={() => handleInvoiceNumberClick(row)}
        >
          {row.InvoiceNumber}
        </span>
      ),
    },
    { key: "PaymentDate", label: "Payment Date" },
    { key: "PaymentMethod", label: "Payment Method" },
    { key: "BillAmount", label: " Bill Amount" },
    { key: "PaidAmount", label: " Paid Amount" },
    { key: "CreatedOn", label: " Created On" },
    { key: "ModifiedOn", label: " Modified On" },
    { key: "ReferenceNumber", label: " Reference Number" },
    { key: "Note", label: "Note" },
    {
      key: "action",
      label: "Action",
      render: (row) => (
        <Button
          type="icon"
          variant="text"
          icon="edit_square"
          size="xs"
          color="black"
          onClick={() => handleEdit(row)}
        />
      ),
      sortable: false,
    },
  ];
  const [showEditPayment, setShowEditPayment] = useState(false);
  const [editRowData, setEditRowData] = useState(null);

  const handleEdit = (row) => {
    setEditRowData(row);
    setShowEditPayment(true);
  };

  // Add id field to each row for TableAdv
  const dataWithIds = tablerowData.map((item, index) => ({
    ...item,
    id: item.id || index, // Use InvoiceNumber or index as fallback
  }));
  console.log(dataWithIds)

  const mappedRows = mapTableRows(dataWithIds, PaymentColumns);

  // Handle selection change from TableAdv
  const handleSelectionChange = (selectedRowIds) => {
    console.log("Selected row IDs:", selectedRowIds);
    setSelectedRows(selectedRowIds);

    // Find the actual row objects from mappedRows
    const selectedRowObjects = mappedRows.filter((row) =>
      selectedRowIds.includes(row.id),
    );

    console.log("Selected row objects:", selectedRowObjects);
  };

  return (
    <div className="flex-1 flex overflow-hidden">
      {showCreatePayment ? (
        <CreatePayment onBack={handleBackToPayments} />
      ) : showEditPayment ? (
        <EditPayment onBack={handleBackToPayments} rowData={editRowData} />
      ) : (
        <TableAdv
          tableId="accountpayable_paymentstable"
          showCheckbox
          columns={PaymentColumns}
          rows={mappedRows}
          onSelectionChange={handleSelectionChange}
          defaultSelectedRows={selectedRows}
          toolbarRight={{
            filter: true,
            search: true,
            add: [
              {
                component: (
                  <Button
                    title="Create Payment"
                    size="sm"
                    color="black"
                    icon="add"
                    onClick={handelcreatePayment}
                  />
                ),
              },
            ],
          }}
        />
      )}
      {/* <Modal
        isOpen={selectedInvoice}
        title={"Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
        zIndex={56}
      >
        <ApInvoiceDetails
          invoice={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={true}
        />
      </Modal> */}
    </div>
  );
};

export default Payments;
